import { $attr, $delegate, $find, $parent, $qs, $setAttr, $setText, $trigger } from 'fxdom/es';
import { defaults, find, go, sel } from 'fxjs/es';
import { BpOptionConstantS } from '../../../BpOption/S/Constant/module/BpOptionConstantS.js';
import { UtilStringS } from '../../../Util/String/S/Function/module/UtilStringS.js';
import { UtilObjS } from '../../../Util/Object/S/Function/module/UtilObjS.js';
import { getIsBizProduct } from '../../S/product.js';

const BOX_PF2_KEY = `maker->product_color->product_faces2`;
const BOX_PF2_BIZ_KEY = `${BOX_PF2_KEY}->${BpOptionConstantS.BIZ_PF2_KEY}`;

const boxBizValuesUpsert = (biz_option_values) => {
  if (box.sel(BOX_PF2_BIZ_KEY)) {
    box.extend2(BOX_PF2_BIZ_KEY, biz_option_values);
  } else {
    box.extend2(BOX_PF2_KEY, {
      [BpOptionConstantS.BIZ_PF2_KEY]: biz_option_values,
    });
  }
};

export const bizOptionMenus = {
  init: () => {
    const { is_pure_biz_product } = getIsBizProduct(box().maker.product_color);
    if (!is_pure_biz_product) return;
    const bp_discount_ranges = box.sel(
      'maker->product_color->_->base_product->_->bp_discount_set->_->bp_discount_ranges',
    );
    if (!bp_discount_ranges?.length) return;
    const quantity = go(
      bp_discount_ranges,
      find(sel('is_default')),
      (bp_discount_range) => bp_discount_range?.start || bp_discount_ranges[0].start,
    );
    if (!box.sel(BOX_PF2_KEY)?.biz?.quantity) boxBizValuesUpsert({ quantity });
  },
  upsert: {
    toBoxAtPf2: (biz_option_values) => {
      biz_option_values = biz_option_values ?? bizOptionMenus.get.bizOptionValuesFromDOM();
      boxBizValuesUpsert(biz_option_values);
    },
  },
  get: {
    el: (key) => {
      if (!Object.values(BpOptionConstantS.BIZ_OPTION_MENU_KEY).includes(key)) {
        throw new Error(`Not exist biz option menu key : ${key}`);
      }

      const { is_biz_product } = getIsBizProduct(box().maker.product_color);
      if (is_biz_product === false) {
        throw new Error(`Not biz product`);
      }

      return $qs(`.${BpOptionConstantS.BIZ_OPTION_MENU_TITLE}.${key}`);
    },
    bizOptionValuesFromBox: () => {
      const biz_option_values = box.sel(BOX_PF2_BIZ_KEY);

      return UtilObjS.isNotEmpty(biz_option_values)
        ? biz_option_values
        : {
            [BpOptionConstantS.BIZ_PF2_DATA_KEYS.FILE_REF_URL]: '',
            [BpOptionConstantS.BIZ_PF2_DATA_KEYS.FILE_REF_NAME]: '',
            [BpOptionConstantS.BIZ_PF2_DATA_KEYS.REQ_MEMO]: '',
            [BpOptionConstantS.BIZ_PF2_DATA_KEYS.QTY]: undefined,
            [BpOptionConstantS.BIZ_PF2_DATA_KEYS.MOQ]: undefined,
          };
    },
    bizOptionValuesFromDOM: () => {
      const biz_option_values = {
        [BpOptionConstantS.BIZ_PF2_DATA_KEYS.FILE_REF_URL]: '',
        [BpOptionConstantS.BIZ_PF2_DATA_KEYS.FILE_REF_NAME]: '',
        [BpOptionConstantS.BIZ_PF2_DATA_KEYS.REQ_MEMO]: '',
        [BpOptionConstantS.BIZ_PF2_DATA_KEYS.QTY]: undefined,
        [BpOptionConstantS.BIZ_PF2_DATA_KEYS.MOQ]: undefined,
      };

      // 파일 참조 url 가져오기
      const file_option_el = bizOptionMenus.get.el(BpOptionConstantS.BIZ_OPTION_MENU_KEY.FILE_REF);
      if (file_option_el) {
        const file_download_el = $find('button[name="download"]', file_option_el);
        if (file_download_el) {
          const file_reference_url = $attr('url', file_download_el);
          const file_reference_name = $attr('filename', file_download_el);
          if (!UtilStringS.isEmNil(file_reference_url)) {
            biz_option_values[BpOptionConstantS.BIZ_PF2_DATA_KEYS.FILE_REF_URL] = file_reference_url;
            biz_option_values[BpOptionConstantS.BIZ_PF2_DATA_KEYS.FILE_REF_NAME] = file_reference_name;
          }
        }
      }

      // 제작 요청 사항 메모 가져오기
      const request_memo_option_el = bizOptionMenus.get.el(BpOptionConstantS.BIZ_OPTION_MENU_KEY.REQ_MEMO);

      if (request_memo_option_el) {
        const input_el = $find('input[type="text"]', request_memo_option_el);
        if (input_el) {
          const memo_str = input_el.value;
          if (!UtilStringS.isEmNil(memo_str)) {
            biz_option_values[BpOptionConstantS.BIZ_PF2_DATA_KEYS.REQ_MEMO] = memo_str;
          }
        }
      }

      return biz_option_values;
    },
  },
};

export const bizOptionMenuEvents = (tab_el) =>
  go(
    /******** 수량 Section */
    tab_el,
    /******** 참고 파일 Section */
    $delegate(
      'click',
      `.section.${BpOptionConstantS.BIZ_OPTION_MENU_KEY.FILE_REF} button[name="upload"]`,
      ({ currentTarget: ct }) => {
        const file_input_el = go(ct, $parent, $find('input[type="file"]'));
        if (file_input_el == null) return;

        file_input_el.click();
      },
    ),
    $delegate(
      'click',
      `.section.${BpOptionConstantS.BIZ_OPTION_MENU_KEY.FILE_REF} button[name="download"]`,
      ({ currentTarget: ct }) => {
        const url = $attr('url', ct);
        const filename = $attr('filename', ct);
        if (url === '' || url == null) return;
        fetch(url)
          .then((res) => res.blob())
          .then((blob) => {
            const a = document.createElement('a');
            const blob_url = window.URL.createObjectURL(blob);
            a.href = blob_url;
            a.download = filename;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(blob_url);
            document.body.removeChild(a);
          })
          .catch((error) => {
            console.error(TT('biz::opt::file_error'), error);
          });
      },
    ),
    $delegate(
      'change',
      `.section.${BpOptionConstantS.BIZ_OPTION_MENU_KEY.FILE_REF} input[type="file"]`,
      async ({ currentTarget: ct }) => {
        // 싱글 파일 업로드만 허용
        const upload_file = ct.files[0];
        if (upload_file != null) {
          // 파일 validation - 확장자 (ai | pdf) , 용량 (10MB)
          const { is_allowed_size, is_allowed_extension } = fileUploadValidation({ upload_file });

          if (is_allowed_size && is_allowed_size) {
            try {
              $.don_loader_start();
              const upload_data = await $.upload(ct);

              if (upload_data) {
                const { original_name, url } = upload_data;
                const filename_el = go(ct, $parent, $find('button[name="download"]'));

                $setAttr({ filename: original_name, url }, filename_el);
                $setText(original_name, filename_el);

                bizOptionMenus.upsert.toBoxAtPf2();
              }
            } catch (err) {
              $.don_loader_end();
              console.error(err);
              $.alert('파일 업로드 중에 문제가 발생하였습니다.');
            } finally {
              $.don_loader_end();
            }
          } else {
            if (!is_allowed_size) {
              $.alert(TT('biz::opt::file_size_error'));
              return;
            }
            if (!is_allowed_extension) {
              $.alert(TT('biz::opt::file_ext_error'));
            }
          }
        }
      },
    ),

    /******** 제작 요청 사항 메모 Section */
    $delegate(
      'focusout',
      `.section.${BpOptionConstantS.BIZ_OPTION_MENU_KEY.REQ_MEMO} input[type="text"]`,
      ({ currentTarget: ct }) => {
        const request_memo = ct.value;
        if (UtilStringS.isEmNil(request_memo)) return;

        bizOptionMenus.upsert.toBoxAtPf2();
      },
    ),
  );

export function handleBizQuantityControl({ pf2, current_qty, cb }) {
  const is_biz = UtilObjS.isNotEmpty(pf2?.biz);

  let target_value;

  if (is_biz) {
    const moq = pf2.biz[BpOptionConstantS.BIZ_PF2_DATA_KEYS.MOQ];
    target_value = Math.max(moq, current_qty);

    const biz_option_quantity_input_el = $qs(
      `.biz-option.${BpOptionConstantS.BIZ_OPTION_MENU_KEY.QTY} input[type='number']`,
    );
    if (biz_option_quantity_input_el) {
      biz_option_quantity_input_el.value = target_value;
      $trigger('change', biz_option_quantity_input_el);
    }
    const mp_select_product_quantity_el = $qs(
      `.biz-option.${BpOptionConstantS.BIZ_OPTION_MENU_KEY.QTY} .mp-select-product-quantity select`,
    );
    if (mp_select_product_quantity_el) {
      mp_select_product_quantity_el.value = target_value;
    }
  } else {
    target_value = current_qty;
  }

  cb && cb(target_value);

  return target_value;
}

// @description 파일 용량제한, 확장자제한 검사
function fileUploadValidation({ upload_file, allowed_condition = {} }) {
  allowed_condition = defaults(allowed_condition, { extensions: ['ai', 'pdf', 'eps'], mega_bytes: 10 });

  const { extensions, mega_bytes } = allowed_condition;

  const res = {
    is_allowed_extension: false,
    is_allowed_size: false,
  };

  if (upload_file != null && upload_file instanceof File) {
    const { name, size } = upload_file;

    const file_extension = name.split('.').pop().toLowerCase();
    res.is_allowed_extension = extensions.includes(file_extension);

    const file_size_in_mega_bytes = size / (1024 * 1024);
    res.is_allowed_size = file_size_in_mega_bytes <= mega_bytes;
  }

  return res;
}
